import React from 'react';
import { Skeleton, Box, Card, CardContent, Slider, useTheme, useMediaQuery } from '@mui/material';

export const FeelingTodaySkeleton: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const wellbeingAreas = [
    { category: 'Mental', description: 'My mental clarity and emotional balance' },
    { category: 'Physical', description: 'My energy levels and physical health' },
    { category: 'Financial', description: 'My financial security and stability' },
    { category: 'Social', description: 'My connections with others and sense of belonging' },
    { category: 'Social', description: 'My connections with others and sense of belonging' },
  ];

  return (
    <Card sx={{ border: 'none', boxShadow: 'none', p: 0, m: 0 }}>
      <CardContent sx={{}}>
        {/* Header */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          mb={2}
          sx={{ textAlign: 'center' }}
        >
          <Skeleton variant="text" width={280} height={62} />
          {/* <Skeleton variant="text" width={60} height={24} /> */}
        </Box>

        {/* Wellbeing Areas */}
        <Box sx={{ mb: 2 }}>
          {wellbeingAreas.map((area, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              {/* Category Header */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Skeleton
                  variant="text"
                  width={80}
                  height={28}
                  sx={{ color: '#019df2', fontWeight: 600 }}
                />
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    bgcolor: '#0072b0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: 600,
                  }}
                >
                  <Skeleton variant="text" width={12} height={20} sx={{ bgcolor: 'white' }} />
                </Box>
              </Box>

              {/* Description */}
              {/* <Skeleton variant="text" width="90%" height={18} sx={{ mb: 1, color: '#6b7280' }} /> */}

              {/* Slider */}
              <Box sx={{}}>
                <Slider
                  value={7}
                  min={1}
                  max={10}
                  disabled
                  sx={{
                    color: '#019df2',
                    height: 8,
                    '& .MuiSlider-track': {
                      border: 'none',
                      backgroundColor: '#019df2',
                    },
                    '& .MuiSlider-rail': {
                      backgroundColor: '#cbd5e1',
                      opacity: 1,
                    },
                    '& .MuiSlider-thumb': {
                      height: 24,
                      width: 24,
                      backgroundColor: '#019df2',
                      border: '3px solid white',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
                        boxShadow: '0 2px 8px rgba(59, 130, 246, 0.4)',
                      },
                    },
                    '& .MuiSlider-mark': {
                      backgroundColor: '#94a3b8',
                      height: 4,
                      width: 4,
                      borderRadius: '50%',
                      '&.MuiSlider-markActive': {
                        backgroundColor: '#019df2',
                      },
                    },
                  }}
                  marks={Array.from({ length: 10 }, (_, i) => ({
                    value: i + 1,
                    label: '',
                  }))}
                />
              </Box>

              {/* Scale Labels */}
              <Box display="flex" justifyContent="space-between" sx={{ mt: -1 }}>
                <Skeleton variant="text" width={28} height={16} />
                <Skeleton variant="text" width={28} height={16} />
              </Box>
            </Box>
          ))}
        </Box>

        {/* Save Button */}
        <Box sx={{ mt: 4 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={56}
            sx={{
              borderRadius: 100,
              bgcolor: '#019df2',
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
